import React from 'react';
import { ClockIcon, FilesIcon, PencilLineIcon, ClipboardCheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { painPoints } from '../../data/content';
const icons = [ClockIcon, FilesIcon, PencilLineIcon, ClipboardCheckIcon];
export function PainSection() {
  return <section aria-labelledby="pain-heading" className="bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-129" data-mp="3m1p99lvnif6i">
      <div className="mx-auto max-w-5xl" data-id="element-130" data-mp="nhysy7cm2s9r">
        <SectionHeading id="pain-heading" title={<>
              Teaching Lashes &amp; Brows Shouldn’t Mean <Accent data-id="element-132" data-mp="dsoyikuaoxih">Hours of Preparation.</Accent>
            </>} data-id="element-131" data-mp="nkuqhukjrexo" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2" role="list" data-id="element-133" data-mp="8udpudfqkt1u">
          {painPoints.map((pain, index) => {
          const Icon = icons[index];
          return <li key={pain.title} className="flex items-start gap-4 rounded-[20px] bg-brand-ivory p-6 shadow-[0_20px_40px_-34px_rgba(24,45,42,0.45)]" data-id="element-134" data-mp="16bcghrdzvwfc" data-mpi={index}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-full bg-brand-blush" data-id="element-135" data-mp="3bflr9wvu2duo">
                  <Icon className="h-5 w-5 text-brand-gold-dark" strokeWidth={1.5} aria-hidden="true" data-id="element-136" data-mp="31ng4r2ocoomv" />
                </span>
                <span data-id="element-137" data-mp="36lrab17m4cza">
                  <span className="block font-display text-[1.35rem] font-bold leading-tight text-brand-charcoal" data-id="element-138" data-mp="36kycipqmsxta">
                    {pain.title}
                  </span>
                  <span className="mt-1.5 block text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-139" data-mp="2woljlu2wunzl">{pain.text}</span>
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-140" data-mp="2nmvi1vfbe8o3">
          You already have the professional skills. <Accent data-id="element-141" data-mp="lwtuya3mn925">Now get the resources</Accent> to teach them with more
          structure.
        </p>
      </div>
    </section>;
}